'use strict';

exports.__esModule = true;

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactApollo = require('react-apollo');

var _context2 = require('@prisma-cms/context');

var _context3 = _interopRequireDefault(_context2);

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var AutocompleteObject = (_temp = _class = function (_Component) {
  _inherits(AutocompleteObject, _Component);

  function AutocompleteObject() {
    _classCallCheck(this, AutocompleteObject);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  } // static propTypes = {
  // };
  // componentWillMount() {
  //   const {
  //     query: {
  //       project,
  //     },
  //   } = this.context;
  //   this.projectQuery = gql(project);
  //   super.componentWillMount && super.componentWillMount();
  // }


  AutocompleteObject.prototype.render = function render() {
    var _context = this.context,
        project = _context.query.project,
        ProjectLink = _context.ProjectLink;
    var where = this.props.where;
    return _react2.default.createElement(_reactApollo.Query, {
      query: (0, _graphqlTag2.default)(project),
      variables: {
        where: where
      }
    }, function (_ref) {
      var loading = _ref.loading,
          error = _ref.error,
          data = _ref.data;
      if (loading) return 'Загрузка...';
      if (error) return "\u041E\u0448\u0438\u0431\u043A\u0430! " + error.message;
      var object = data.object;
      return _react2.default.createElement(ProjectLink, {
        object: object
      });
    });
  };

  return AutocompleteObject;
}(_react.Component), _class.contextType = _context3.default, _temp);
exports.default = AutocompleteObject;
module.exports = exports['default'];